import { Observable } from 'rxjs';
import { Group } from '.';
import { Bundle } from './bundle';

export class ContactManagerData {
  fields: ContactField[];
  groups?: Observable<Group[]>;
  selectedGroup?: Group;
}

export type ContactField = 'new' | 'group' | 'file' | 'text' | 'auto';

// export class SelectOption {
  //   name: string;
  //   value: any;
  // }

export class CustomBundleData {
  bundles: Bundle[] = [];
  currency: string = '';
  customAmount: number = 0;
  customCredit: number = 0;

  constructor() {}
}